module.exports = __webpack_public_path__ + "img/senalando-izqus.png.d92622d7.webp";